var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imageData)?_c('b-img-lazy',_vm._b({attrs:{"fluid":"","src":_vm.imageData,"rounded":_vm.rounded}},'b-img-lazy',_vm.mainProps,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }